











import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class SummaryLine extends Vue {
  @Prop({ default: "normal" }) readonly type!: string;
  @Prop({ default: false }) readonly title!: boolean;
  @Prop({ default: false }) readonly value!: boolean;
}
